import baseStyles from './ActionPanel.module.scss';

export function PanelDivider() {
  return <hr className={baseStyles.divider} />;
}
